const zipperTeaserStyle = {
  paper: {
    padding: "2rem",
  },
};

export default zipperTeaserStyle;
